// extracted by mini-css-extract-plugin
module.exports = {"fontFontAwesome":"\"Font Awesome 5 Free\", sans-serif","fontSourceSansPro":"\"Source Sans Pro\", sans-serif"};